

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { myLocalStorage } from "../../../../components/StorageHelper";
import { NGROK } from "../../../../APIs";
import axios from "axios";
import useUserStore from "../../../../services/userStore";
import CloudEntityAnalytics from "../../../../components/v2components/CloudAnalytics/CloudEntityAnalytics";

const AzureUserInfo = () => {
  const location = useLocation();
  const { user: initialUser } = location.state || { user: {} };
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [user, setUser] = useState(initialUser);
  const [, setGroups] = useState(initialUser?.groups || []);
  const [, setRoleDefinitions] = useState(
    initialUser?.roleDefinitions || [],
  );
  const [, setSelectedTab] = useState("analytics");

  const [, setSubList] = useState([]);
  const [, setSelectedSubList] = useState(null);
  const latestSubId = JSON.parse(
    myLocalStorage.getItem("latestSubList"),
  )?.azureSubscriptionId;

   const latestSubName= JSON.parse(
    myLocalStorage.getItem("latestSubList"),
  )?.subscriptionName;


  const latestSubList = myLocalStorage.getItem("latestSubList");
  const { role } = useUserStore((state) => state.user);

  const {
    azureId,
    syncedAt,
    azureUserId,
    userPrincipalName,
    mail,
  } = user;
  const analyticsEmail =
    user?.email ||
    mail ||
    user?.userDetails?.mail ||
    user?.userDetails?.userPrincipalName ||
    userPrincipalName ||
    "-";




  const getSpecificUsers = async () => {
    let id = azureId || azureUserId || null;
    if (id !== null) {
      try {
        const response = await axios.get(
          `${NGROK}/api/azure/v1/users/getRolesAndGroups?tenantName=${latestTenant}&azureId=${id}`,
        );
        if (response?.data) {
          let specificUserdata = response?.data[0];
          setUser(specificUserdata);
          setGroups(specificUserdata?.groups);
          setRoleDefinitions(specificUserdata?.roleDefinitions);
        }
      } catch (e) {}
    }
  };

  const fetchUserSubList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/azureResources/v1/users/subscriptions?tenantName=${latestTenant}&userId=${azureId || azureUserId}`,
      );

      const subs = response?.data || [];
      setSubList(subs);

      if (subs.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestSubList === "string"
              ? JSON.parse(latestSubList)
              : latestSubList;
        } catch (e) {
          latest = null;
        }

        const match = latest
          ? subs.find(
              (item) =>
                item?.name === latest?.name ||
                item?.name === latest?.subscriptionName,
            )
          : null;

        const selected = match || subs[0];

        setSelectedSubList(selected);

        myLocalStorage.setItem("latestSubList", JSON.stringify(selected));
      } else {
        setSelectedSubList(null);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setSubList([]);
      setSelectedSubList(null);
    }
  };

  useEffect(() => {
    if (role === "TENANT_USER") {
      setSelectedTab("resources");
      fetchUserSubList();
    } else {
      setSelectedTab("analytics");
    }
    const interval = setInterval(() => {
      getSpecificUsers();
    }, [5000]);
    return () => clearInterval(interval);
  }, [initialUser]);

  return <CloudEntityAnalytics cloudProvider={"azure"} email={analyticsEmail} entityId={azureId || azureUserId || "-"} entityType="user" projectId={latestSubId} roles={initialUser?.roles || []} syncedAt={syncedAt} entityName={latestSubName} details={initialUser} />

};

export default AzureUserInfo;
